import React, { FC, useEffect, useRef, useState } from 'react';
import { DefaultLayoutPadding } from '../../../constants/Layout';
import theme, { BorderColors } from '../../../theme';
import { FlexContainer } from '../Container';
import { LineRoundedEye, LineRoundedEyeOff } from '../icons/exported';
import { Description, Error, Label } from '../InputText/style';
import { EyeIconContainer, PasswordInput, PasswordInputContainer } from './style';

export interface PasswordInputTextProps {
  borderColor?: BorderColors;
  name: string;
  label?: string;
  description?: string;
  autoFocus?: boolean;
  error?: string;
  showToggle?: boolean;
  [x: string]: any;
}

const PasswordInputText: FC<PasswordInputTextProps> = ({
  borderColor,
  error,
  name,
  label,
  description,
  autoFocus,
  showToggle = true,
  ...otherProps
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const inputRef = useRef(null);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  useEffect(() => {
    autoFocus && inputRef.current.focus();
  }, [autoFocus]);

  return (
    <FlexContainer style={{ position: 'relative' }} flexDirection="column">
      {label && <Label htmlFor={name}>{label}</Label>}
      {description && <Description>{description}</Description>}
      <Error
        style={{
          position: 'absolute',
          top: label ? '20px' : '-20px',
          paddingLeft: theme.spacing[DefaultLayoutPadding],
        }}
      >
        {error}
      </Error>
      <PasswordInputContainer>
        <PasswordInput
          borderColor={borderColor}
          error={error}
          name={name}
          showToggle={showToggle}
          type={isPasswordVisible ? 'text' : 'password'}
          {...otherProps}
          ref={inputRef}
        />
        {showToggle && (
          <EyeIconContainer onClick={togglePasswordVisibility}>
            {isPasswordVisible ? <LineRoundedEyeOff /> : <LineRoundedEye />}
          </EyeIconContainer>
        )}
      </PasswordInputContainer>
    </FlexContainer>
  );
};

export default PasswordInputText;
